module.exports = __webpack_public_path__ + "static/media/andre_ramos.b049ae70.jpg";